import { render, staticRenderFns } from "./StageBlock.vue?vue&type=template&id=f56a5d06"
import script from "./StageBlock.vue?vue&type=script&lang=js"
export * from "./StageBlock.vue?vue&type=script&lang=js"
import style0 from "./StageBlock.vue?vue&type=style&index=0&id=f56a5d06&prod&scss=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports